import { render, staticRenderFns } from "./quillEditor.vue?vue&type=template&id=2146ffe0&scoped=true"
import script from "./quillEditor.vue?vue&type=script&lang=js"
export * from "./quillEditor.vue?vue&type=script&lang=js"
import style0 from "./quillEditor.vue?vue&type=style&index=0&id=2146ffe0&prod&lang=scss"
import style1 from "./quillEditor.vue?vue&type=style&index=1&id=2146ffe0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2146ffe0",
  null
  
)

export default component.exports